module.exports = __webpack_public_path__ + "images/traffic_light_grey_baked.a3c5f810427e55e1926aa72b50655da8.png";